import { AvailabilityTimeQuery } from '@models/response/availabilityTime';
import { AvailabilityTimeQueryResponse, WeekDay } from '@models/ropolo';
import moment from 'moment';
import businessConfig from '../config/business';
import timeUtil from './timeUtil';

const isVendorOpen = (availabilityTimes: AvailabilityTimeQueryResponse[], isActive: boolean) => {
  const todayName = moment().format('ddd').toUpperCase() as WeekDay;

  const isOpen = availabilityTimes
    .filter((time) => time.dayOfWeek === todayName)
    .some((time: AvailabilityTimeQuery) => {
      const { startTime, endTime } = time;

      return timeUtil.isNowInRange(startTime || '', endTime || '');
    });

  return isOpen && isActive;
};

const parseVendorDomain = (domain: string) => {
  const reqDomain = new URL(`http://${domain}`).hostname.replace('www.', '');

  let subdomain = '';
  let customDomain = '';

  if (reqDomain.endsWith(`.${businessConfig.domain}`)) {
    subdomain = reqDomain.replace(`.${businessConfig.domain}`, '');
  } else {
    customDomain = reqDomain;
  }

  return subdomain || customDomain;
};

const getVendorDomain = () => {
  const reqDomain = new URL(`http://${window.location.hostname}`).hostname.replace('www.', '');

  let domain = '';

  if (reqDomain.endsWith(`.${businessConfig.domain}`)) {
    domain = reqDomain.replace(`.${businessConfig.domain}`, '');
  } else {
    domain = reqDomain;
  }
  return domain;
};

const VendorUtil = {
  isVendorOpen,
  parseVendorDomain,
  getVendorDomain,
};

export default VendorUtil;
